export const webcamAllowed = () => !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
